// extracted by mini-css-extract-plugin
export default {"trigger":"-ulQk","skeleton-progress":"f9-pi"};